import React, { ReactNode } from "react";
import { FaPaypal, FaUniversity } from "react-icons/fa";
import { SiPayoneer } from "react-icons/si";
import "./modal.scss";
import { IPayoneer, IPayPal, PaymentMethod } from "../../profile/types";
// import "./styles.scss";

export interface PaymentDetails {
  email?: string;
  payoneerId?: string;
  bankAccount?: string;
}

// export interface PaymentOption {
//   id: string;
//   type?: string;
//   details: PaymentDetails;
// }

// interface PaymentOption {
//   id: string;
//   type: string;
//   accountEnding: string;
//   details: {
//     isPrimary: boolean;
//     payoneerId: string;
//     email?: string | undefined;
//   };
// }

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  options: PaymentMethod[];
  selectedId?: PaymentMethod;
  onSelect: (item: PaymentMethod) => void;
}

export const getIcon = (type: string): JSX.Element | null => {
  const iconProps = { className: `pay-icon ${type.toLowerCase()}` };
  console.log(iconProps);

  switch (type.toLowerCase()) {
    case "paypal":
      return typeof FaPaypal === "function"
        ? (FaPaypal(iconProps) as JSX.Element)
        : null;
    case "bank":
      return typeof FaUniversity === "function"
        ? (FaUniversity(iconProps) as JSX.Element)
        : null;
    case "payoneer":
      return typeof SiPayoneer === "function"
        ? (SiPayoneer(iconProps) as JSX.Element)
        : null;
    default:
      return null;
  }
};

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  options,
  selectedId,
  onSelect,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h2>Select a Payment Option</h2>
        <div className="payment-options">
          {options.length < 1 ? (
            <p className="payMethodText">
              You haven't added a payout account yet. <br />
              Please go to your <a href="../profile">profile</a> and provide the
              required information.
            </p>
          ) : (
            options.map((item: PaymentMethod, index: number) => {
              const isSelected = selectedId?.id === item.id;
              return (
                <div
                  key={index}
                  className={`payment-card ${isSelected ? "selected" : ""}`}
                  onClick={() => onSelect(item)}
                >
                  {getIcon(item.type as string)}
                  <div className="card-details">
                    <h3>{item.type}</h3>
                    <p>
                      {(item.details as IPayPal).email ||
                        (item.details as IPayoneer)?.payoneerId ||
                        "Not provided"}
                    </p>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
